module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_1@3x.03af95d7.png";